import request from '@/utils/analyticsRequest';

function analyticsApiUrl(path) {
  const base = (process.env.VUE_APP_ANALYTICS_API || '').trim().replace(/\/$/, '');
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${base}${normalizedPath}`;
}

export function listGhlSites() {
  return request({ url: '/api/v1/ghl/sites', method: 'get' });
}

export function createGhlSite(data) {
  return request({ url: '/api/v1/ghl/sites', method: 'post', data });
}

export function getGhlSite(siteId) {
  return request({ url: `/api/v1/ghl/sites/${encodeURIComponent(siteId)}`, method: 'get' });
}

export function updateGhlSite(siteId, data) {
  return request({
    url: `/api/v1/ghl/sites/${encodeURIComponent(siteId)}`,
    method: 'patch',
    data
  });
}

export function updateGhlSitePage(siteId, pageId, data) {
  return request({
    url: `/api/v1/ghl/sites/${encodeURIComponent(siteId)}/pages/${encodeURIComponent(pageId)}`,
    method: 'patch',
    data,
    headers: { 'Content-Type': 'application/json' }
  });
}

export function publishGhlSitePage(siteId, pageId) {
  return request({
    url: `/api/v1/ghl/sites/${encodeURIComponent(siteId)}/pages/${encodeURIComponent(pageId)}/publish`,
    method: 'post'
  });
}

export function previewGhlSitePageUrl(siteId, pageId) {
  return analyticsApiUrl(
    `/api/v1/ghl/sites/p/preview/${encodeURIComponent(siteId)}/${encodeURIComponent(pageId)}`
  );
}

export function publicGhlSiteUrl(slug) {
  return analyticsApiUrl(`/api/v1/ghl/sites/p/${encodeURIComponent(slug)}`);
}
